module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Batch #{0}","search":"Search","tabs":{"ALL":"All","FAILED":"Failed"}}}')
  delete Component.options._Ctor
}
